export let routes = [
  {
    path: '/x3-side-commentReply',
    name: 'x3-side-commentReply',
    component: () => import('@x3/js/side/comment/comment-reply.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
  {
    path: '/x3-side-momentVideoType',
    name: 'x3-side-momentVideoType',
    component: () => import('@x3/js/side/comment/moment-video-type.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  xsCommentReply(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-commentReply',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
  xsMomentVideoType(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-momentVideoType',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};
